<nav class="navbar navbar-expand-lg navbar-light bg-blue">
  <div class="container-fluid">
    <a class="navbar-brand ms-2 fw-bold" routerLink="{{ guid }}/dashboard">
      <img
        src="/assets/img/PersonnelPulseLogo_White.png"
        style="max-height: 3vh; width: auto"
      />
    </a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a
            class="nav-link"
            tabindex="-1"
            routerLink="{{ guid }}/dashboard"
            routerLinkActive="active"
            >Dashboard</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            class="nav-link"
            tabindex="-1"
            routerLink="{{ guid }}/calendar"
            routerLinkActive="active"
            >Calendar</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link"
            tabindex="-1"
            routerLink="{{ guid }}/shifts"
            routerLinkActive="active"
            >Shifts</a
          >
        </li>
        <li class="nav-item" *ngIf="isAccountManager">
          <a
            class="nav-link"
            class="nav-link"
            tabindex="-1"
            routerLink="{{ guid }}/scheduler"
            routerLinkActive="active"
            >Scheduler</a
          >
        </li>
        <li class="nav-item" *ngIf="enableRequestOff">
          <a
            class="nav-link"
            class="nav-link"
            tabindex="-1"
            routerLink="{{ guid }}/timeoff-requests"
            routerLinkActive="active"
            >Time Off</a
          >
        </li>
        <li class="nav-item" *ngIf="enableTimesheets">
          <a
            class="nav-link"
            class="nav-link"
            tabindex="-1"
            routerLink="{{ guid }}/timesheets"
            routerLinkActive="active"
            >Timesheets</a
          >
        </li>

        <li class="nav-item dropdown" *ngIf="isAccountManager">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
            [class.active]="addActiveClassToAdminDropdown()"
          >
            Administration
          </a>
          <ul
            class="dropdown-menu"
            aria-labelledby="navbarDropdown"
            *ngIf="isAccountManager"
          >
            <li>
              <a
                *ngIf="isAdmin"
                class="dropdown-item"
                routerLink="{{ guid }}/admin/accounts"
                routerLinkActive="active"
                >Accounts</a
              >
            </li>

            <li>
              <a
                class="dropdown-item"
                routerLink="{{ guid }}/admin/clients"
                routerLinkActive="active"
                >{{ clientTag }}s</a
              >
            </li>

            <li>
              <a
                class="dropdown-item"
                routerLink="{{ guid }}/admin/facility-types"
                routerLinkActive="active"
                >Facility Types</a
              >
            </li>

            <li>
              <a
                class="dropdown-item"
                routerLink="{{ guid }}/admin/{{ employeeRoute }}"
                routerLinkActive="active"
                >{{ employeeTag }}s</a
              >
            </li>

            <li>
              <a
                class="dropdown-item"
                routerLink="{{ guid }}/admin/users"
                routerLinkActive="active"
                >Users</a
              >
            </li>
            <li>
              <a
                class="dropdown-item"
                routerLink="{{ guid }}/call-offs"
                routerLinkActive="active"
                >Call Offs</a
              >
            </li>
            <li *ngIf="isAccountManager">
              <a
                class="dropdown-item"
                tabindex="-1"
                routerLink="{{ guid }}/exports"
                routerLinkActive="active"
                >Exports</a
              >
            </li>
            <li>
              <a
                class="dropdown-item"
                tabindex="-1"
                routerLink="{{ guid }}/notifications"
                routerLinkActive="active"
                >Notifications</a
              >
            </li>
          </ul>
        </li>
      </ul>

      <a
        class="navbar-brand col-2 ms-auto text-end fw-bold"
        routerLink="{{ guid }}/dashboard"
      >
        <img
          *ngIf="currentAccount.fileGuid != null"
          [src]="apiRoot + 'api/v1/file/download/' + currentAccount.fileGuid"
          class="nav-logo me-2"
        />
        {{ currentAccountName }}
      </a>

      <li class="nav-item dropdown me-4" style="list-style-type: none">
        <a
          class="nav-link dropdown-toggle"
          id="navbarDropdown"
          role="button"
          data-bs-toggle="dropdown"
          aria-expanded="false"
        >
          <span class="nav-username text-light fw-bold me-1">{{
            welcome
          }}</span>
        </a>

        <ul class="dropdown-menu mt-2" aria-labelledby="navbarDropdown">
          <li>
            <a class="dropdown-item" routerLink="user-accounts"
              >Switch Accounts</a
            >
          </li>
        </ul>
      </li>

      <button
        class="btn btn-sm btn-danger me-2"
        (click)="onSignout()"
        tabindex="-1"
      >
        Sign Out
      </button>
      <button
        *ngIf="currentAccount.demo == true"
        routerLink="{{ guid }}/demo"
        class="btn btn-sm btn-success me-2"
      >
        How to Purchase
      </button>
      <button
        *ngIf="currentAccount.demo == true && isAccountManager"
        routerLink="{{ guid }}/admin/quick-setup"
        class="btn btn-sm btn-secondary me-2"
      >
        Quick-Setup
      </button>
      <button
        routerLink="contact"
        class="btn btn-sm btn-secondary ps-1 pe-1 circle-button"
      >
        <div>?</div>
      </button>
    </div>
  </div>
</nav>

<ng-template #timeout>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title">
      Your session is about to timeout!
    </h4>
  </div>
  <div class="modal-body">
    <p class="text-center mb-0">{{ count }} seconds</p>
  </div>
  <div class="modal-footer">
    <button type="submit" class="btn btn-primary btn-sm" (click)="onContinue()">
      Stay Logged In
    </button>
    <button
      type="submit"
      class="btn btn-danger btn-sm"
      (click)="onManualLogout()"
    >
      Log Out
    </button>
  </div>
</ng-template>
